module.exports = __webpack_public_path__ + "img/0003-filler.f737315f.jpg";